import {AbstractStatefulView, LitRenderer} from "../../../../admin/script/views/abstract-view.js";
import template from './chat-outer-template.js';
import {createRef} from '../../../../admin/script/libs/lit.dist.js';
import {scrollToBottom} from "../../../../admin/script/util/browser.js";
import {DEFAULT_USER_MESSAGE} from "../types.js";
import {TakePhotoModal} from "../../js/take-photo-modal.js";
import {showErrorPopup} from "../../../util/errors.js";
import {createTimedPulseAnimation} from "../../../util/animations.js";
import {WEEK} from "../../../../admin/script/util/time.js";
import {showLoginDialog} from "../../js/dialogs/login-dialog.js";


export class ChatView extends AbstractStatefulView {

    constructor({chat, ...props}) {
        super(props);
        this.chat = chat;
        this.template = template;
        this.state = {
            showTakePhotoButton: false,
            message: {...DEFAULT_USER_MESSAGE},
        };

        this.takePhotoModal = new TakePhotoModal();
        this.takePhotoModal.hasAvailableCameras().then(hasCameras => {
            this.setState({showTakePhotoButton: hasCameras});
        });
        this.messagesContainerRef = createRef();
    }

    getDefaultRenderer() {
        return new LitRenderer();
    }

    storeEvents() {
        return {
            'change:messages': (messages, previousMessages) => {
                this.rerender();
                if (messages.length !== previousMessages.length) {
                    this.scrollToBottom();
                }
            },
            'change:state': () => this.rerender(),
            'change:state:isChatVisible': (isChatVisible) => {
                document.body.classList.toggle('has-chat-opened', isChatVisible);
            },
        };
    }

    scrollToBottom() {
        scrollToBottom(this.messagesContainerRef.value);
    }

    getFilteredSortedMessages() {
        return _.sortBy(this.store.get('messages', []), m => new Date(m.date).getTime());
    }

    templateContext() {
        return {
            messages: this.getFilteredSortedMessages(),
            setMessageContent: content => this.setState({message: {...this.state.message, content}}),
            toggleChat: () => this.store.merge('state', {isChatVisible: !this.store.get('state', {}).isChatVisible}),
            onClickSendButton: this.onClickSendButton.bind(this),
            onPaste: this.onPaste.bind(this),
            onSelectFile: this.onSelectFile.bind(this),
            onClickRemoveAttachedFile: attachment => {
                this.setState({
                    message: {
                        ...this.state.message,
                        attachments: this.state.message.attachments.filter(m => m.id !== attachment.id),
                    }
                });
            },
            onClickSuggestion: this.handleSuggestion.bind(this),
            showTakePhotoModal: async () => {
                try {
                    const image = await this.takePhotoModal.show();
                    if (image) {
                        this.uploadFile(image).then();
                    }
                } catch (e) {
                    showErrorPopup(e);
                }
            },
            messagesContainerRef: this.messagesContainerRef,
            scrollToBottom: this.scrollToBottom.bind(this),
            ...this.store.get('state', {}),
            ...this.state,
        };
    }

    handleSuggestion(handler) {
        if (handler === '@AUTH_LOG_IN') {
            showLoginDialog({
                onAuthorizedCallback: () => {
                    this.chat.processLastUserMessage().then();
                },
            });
            return;
        }
        this.chat.postMessage(handler);
    }

    firstRendered() {
        super.firstRendered();
        createTimedPulseAnimation('pk-chat-toggle-button-pulse', WEEK, {times: 1});
    }

    async onSelectFile(e) {
        for (let file of e.target.files) {
            this.uploadFile(file).then();
        }
    }

    async onPaste(e) {
        const file = e.clipboardData.items[0] ? e.clipboardData.items[0].getAsFile() : null;
        if (file && !this.state.isUploadingFile) {
            return this.uploadFile(file);
        }
    }

    async uploadFile(file) {
        this.setState({isUploadingFile: true});
        try {
            const uploadedFile = await this.chat.uploadFile(file);
            if (uploadedFile && uploadedFile.id) {
                this.setState({
                    message: {
                        ...this.state.message,
                        attachments: [
                            ...this.state.message.attachments,
                            {
                                ...uploadedFile,
                                url: URL.createObjectURL(file),
                                file
                            },
                        ],
                    }
                });
            }
        } catch (e) {
        }
        this.setState({isUploadingFile: false});
    }

    async onClickSendButton() {
        const message = this.state.message;
        this.setState({message: {...DEFAULT_USER_MESSAGE}});
        await this.chat.postMessage(message.content, message.attachments);
        this.scrollToBottom();
    }

}
